module.exports = __webpack_public_path__ + "static/media/background-photo1024.24d513fd.jpg";